var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-1 px-0",attrs:{"color":_vm.active ? 'primary' : 'primary lighten-2',"ripple":false,"depressed":"","width":"32","height":"32","min-width":"32","rounded":"","disabled":_vm.disabled}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }